import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, signInAnonymously } from "firebase/auth";

// Configuración Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBHCFa7nRUhzBQem-sHCXd3D8z2V5uK2Rc",
  authDomain: "goodlookapp.firebaseapp.com",
  projectId: "goodlookapp",
  storageBucket: "goodlookapp.appspot.com",
  messagingSenderId: "432447057224",
  appId: "1:432447057224:web:b884c6355a366f2f56d77d"
};

// ✅ Evita inicializar múltiples veces (clave)
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

const auth = getAuth(app);

signInAnonymously(auth)
    .catch((error) => {
        console.error("Firebase anonymous auth failed", error);
    });

// ⚠️ Importante: usa "goodlook" solo si tu proyecto realmente lo necesita
// Si sigue fallando con Datastore error → cambia a getFirestore(app)
export const db = getFirestore(app, "goodlook");
export { auth };
